module.exports = __webpack_public_path__ + "img/logo.54b53262.svg";